import React from "react";
import { useTranslation } from "react-i18next";
import InputColor from "./InputColor";
import MultiOptionsInput from "./MultiOptionsInput";

const ColorSelector = ({
  storefrontMainColor = "",
  storefrontSecondaryTextColor = "white",
  onChange = () => {},
  onChangeColor = () => {},
}) => {
  const { t } = useTranslation(["dashboard", "common"]);
  return (
    <div className="color-selector">
      <label>{t("branding.storefrontColor")}</label>
      <InputColor
        inputName="storefrontMainColor"
        inputNameColor="storefrontMainColorPicker"
        value={storefrontMainColor}
        onChange={onChangeColor}
      />
      <label>{t("branding.storefrontSecondaryColorText")}</label>
      <MultiOptionsInput
        value={storefrontSecondaryTextColor}
        onChange={onChange}
        options={["white", "black"]}
        optionLabels={{
          white: t("common:colors.white"),
          black: t("common:colors.black"),
        }}
        inputName="storefrontSecondaryTextColor"
      />
    </div>
  );
};

export default ColorSelector;
